module.exports = __webpack_public_path__ + "media/images/area/maps/kyushu-93a75a0fe930c80a9743717e3f6c5d98.svg";